import { Link } from "react-router-dom";
import { CheckCircle, Home, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const PaymentSuccessPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center" data-testid="payment-success-page">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Thank You</h1>
        <p className="text-gray-600 mb-2">
          Your bank transfer instructions are on your invoice and in the customer portal.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          Once funds clear (usually within 1 working day) we&apos;ll mark your payment as received.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/customer-portal">
            <Button className="w-full bg-primary hover:bg-primary/90" data-testid="goto-portal-btn">
              <Mail className="w-4 h-4 mr-2" />
              View My Portal
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full" data-testid="goto-home-btn">
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
